export const designProjs = [
    {
        src: "https://www.behance.net/embed/project/184227427?ilo0=1",
        title: "cowculator"
    },
    {
        src: "https://www.behance.net/embed/project/134015559?ilo0=1",
        title: "portfolio-2021"
    }
]